(function () {
  var root = document.querySelector('.flp-page');
  if (!root || root.getAttribute('data-flp-media-warm') === 'true') return;

  root.setAttribute('data-flp-media-warm', 'true');

  function warmImages() {
    var images = Array.prototype.slice.call(root.querySelectorAll('img'));

    images.forEach(function (image) {
      image.loading = 'eager';
    });

    function decodeImages() {
      var pending = images.map(function (image) {
        if (typeof image.decode !== 'function') return Promise.resolve();
        return image.decode().catch(function () {});
      });

      Promise.all(pending).then(function () {
        root.setAttribute('data-flp-images-decoded', 'true');
      });
    }

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(decodeImages, { timeout: 1200 });
    } else {
      window.setTimeout(decodeImages, 120);
    }
  }

  function warmVideos() {
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-flp-compare-video]'));

    videos.forEach(function (video) {
      video.preload = 'auto';
      if (video.networkState === 0 && typeof video.load === 'function') {
        video.load();
      }
    });
  }

  function warmMedia() {
    warmImages();
    warmVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', warmMedia, { once: true });
  } else {
    warmMedia();
  }
})();
